<template>
	<div class="container">
		<van-sticky>
		<div class="main_box">
			<!--块1-->
			<div
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
				class="block_1"
			>
				<div class="left">
					<img src="../../assets/img_public/logo.webp" @click="goIndex" />
				</div>
				<div class="right">
					<div class="lang" @click="checkCN">中文</div>
					<div class="icon" style="top: -6px;" @click="goSearch">
						<!-- <van-icon name="search" size="24px" color="#333333" /> -->
						<img src="../../assets/img_public/nav/icon_search_h5.webp" />
					</div>
					<div class="icon">
						<van-icon v-if="!isShow" name="wap-nav" size="24px" color="#333333" @click="showSlide" />
						<van-icon v-else name="cross" size="24px" color="#C8000A" @click="showSlide" />
					</div>
				</div>
			</div>
			<!--块1-->
		</div>
		</van-sticky>
		<!--折叠导航-->
		<div class="slide_box" :class="isShow ? 'height-slide' : ''" :border="false">
			<div style="padding: 32px 0 16px 16px;font-size: 16px;" @click="goIndex">Home</div>
			<van-collapse v-model="activeName" accordion>
				<van-collapse-item
					v-for="(value, index) in navData"
					v-if="value.route != 'Index' && value.route != 'Contact'"
					:key="index"
					:name="value.title"
					:border="false"
				>
					<template #title>
						<div class="title">{{ value.title }}</div>
					</template>
					<template v-if="value.route == 'Product'">
						<div class="product_list">
							<div class="tit_tit" @click="oneNavClick(value)">ALl Product</div>
							<div v-if="value.children.scenarios_list.length > 0" class="tit_box">
								<div class="tit">Solution</div>
								<div v-for="(value2, index2) in value.children.scenarios_list" :key="index2" class="txt" @click="goProduct(1, value2)">{{ value2.title }}</div>
							</div>
							<div v-if="value.children.cate_list.length > 0" class="tit_box">
								<div class="tit">Product Category</div>
								<div v-for="(value2, index2) in value.children.cate_list" :key="index2" v-if="value2.title != 'Solution'" class="txt" @click="goProduct(2, value2)">{{ value2.title }}</div>
							</div>
						</div>
					</template>
					<template v-else>
						<div v-for="(value2, index2) in value.children" :key="index2" class="text" @click="oneNavClick(value2, true)">{{ value2.title }}</div>
					</template>
				</van-collapse-item>
			</van-collapse>
			<div style="padding: 16px 0 16px 16px;font-size: 16px;" @click="goContact">Contact Us</div>
		</div>
		<!--折叠导航-->
	</div>
</template>

<script>
	export default {
		components: {
			//
		},
		data() {
			return {
				navData: [],
				isShow: false,
				activeName: '',
				lang: sessionStorage.getItem('lang')
			}
		},
		created() {
			let that = this;
			if(sessionStorage.getItem('navList')) {
				that.navData = JSON.parse(sessionStorage.getItem('navList'));
			}
		},
		mounted() {
			let that = this;
		},
		watch: {
			//
		},
		methods: {
			//点击进入产品
			goProduct(type, value) {
				let that = this;
				switch(type) {
					case 1:
						that.$router.push({ path: '/product.html', query: { scenarios_ids: value.id } });
						setTimeout(() => {
							window.location.reload();
						}, 300);
					break;
					case 2:
						that.$router.push({ path: '/product.html', query: { cate_ids: value.id } });
						setTimeout(() => {
							window.location.reload();
						}, 300);
					break;
				}
			},
			//切换cn
			checkCN() {
				sessionStorage.clear();
				localStorage.clear();
				window.location.replace("https://abiores.com.cn/");
				// window.location.href = 'https://abiores.com/';
			},
			//一级导航点击
			oneNavClick(value, value2) {
				let that = this;
				if(that.$route.path != value.url) {
					if(value2) {
						if(that.$route.name === value.route) {
							that.$router.push({ path: value.url, });
							window.location.reload();
						}else {
							if(that.$route.path != value.url) {
								that.$router.push({ path: value.url, });
								setTimeout(() => {
									window.location.reload();
								}, 300);
							}
						}
					}else {
						that.$router.push({ path: value.url });
					}
				}else {
					window.location.reload();
				}
			},
			//显示/隐藏导航
			showSlide() {
				let that = this;
				that.isShow = !that.isShow;
			},
			//点击搜索
			goSearch() {
				if (this.$route.path != '/search.html') {
					this.$router.push({
						path: '/search.html'
					});
				} else {
					window.location.reload();
				}
			},
			//点击联系我们
			goContact() {
				if (this.$route.path != '/contact.html') {
					this.$router.push({
						path: '/contact.html'
					});
				} else {
					window.location.reload();
				}
			},
			//点击首页
			goIndex() {
				if (this.$route.path != '/') {
					this.$router.push({
						path: '/'
					});
				} else {
					window.location.reload();
				}
			},
		}
	}
</script>

<style lang="less" scoped>
.slide_box {
	color: #333333;
	position: fixed;
	z-index: 2;
	width: 100%;
	background-color: #ffffff;
	max-height: 0;
	transition: max-height 0.75s;
	overflow: hidden;
	height: 100vh;
	background-color: #ffffff;
	.product_list{
		padding: 20px 16px;
		background-color: #F6F6F6;
		color: #666666;
		.tit_box{
			padding: 10px 0 0 0;
			.txt{
				padding: 6px 0 6px 20px;
				font-size: 16px;
			}
			.tit{
				padding-bottom: 10px;
				font-size: 16px;
			}
		}
		.tit_tit{
			font-size: 16px;
		}
	}
	.van-collapse{
		.van-collapse-item{
			padding: 16px 0 0 0;
			// border-bottom: 1px solid #E3E1E6;
		}
	}
	.title{
		padding: 0px 16px 18px 16px;
		font-size: 16px;
	}
	.text:first-child{
		padding-top: 20px;
	}
	.text{
		padding: 0px 16px 20px 16px;
		font-size: 16px;
		color: #666666;
		background-color: #F6F6F6;
	}
	div.actived{
		background-color: #f5f8fa;
		color: #0B318F;
	}
}
.height-slide {
	max-height: 1000px;
}
.main_box {
	color: #333333;
	background-color: #ffffff;
	.block_1{
		display: flex;
		align-items: center;
		height: 55px;
		padding: 0 16px;
		border-bottom: 1px solid #C8000A;
		.right{
			flex: 1;
			text-align: right;
			.icon{
				position: relative;
				top: 4px;
				margin-left: 16px;
				display: inline-block;
				img{
					width: 28px;
				}
			}
			.lang{
				display: inline-block;
				font-size: 16px;
			}
		}
		.left{
			img{
				width: 130px;
			}
		}
	}
}
</style>
<style scoped>
>>> .slide_box .van-hairline--top-bottom::after, >>> .slide_box .van-hairline-unset--top-bottom::after{
	border: none;
}
>>> .slide_box .van-cell, >>> .slide_box .van-collapse-item__content{
	padding: 0;
}
>>> .slide_box .van-cell--clickable{
	background-color: transparent;
}
>>> .slide_box .van-cell__right-icon{
	right: 16px;
}
</style>